import * as React from 'react';
import {Box, Card, CardContent, IconButton, Stack, Tooltip, Typography} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import type {Template} from '../../../../types/templates';
import {fmtDateTime} from '../../../../utils/utils';
import SendIcon from '@mui/icons-material/Send';

type Props = {
  item: Template;
  onMenu: (id: string, anchor: HTMLElement) => void;
  onTest: (id: string) => void;
};

export default function TemplateCard({item, onMenu,onTest}: Props) {
  const handleMenuClick = (e: React.MouseEvent<HTMLButtonElement>) => {
    onMenu?.(item.id, e.currentTarget);
  };

  return (
    <Card variant="outlined" sx={{borderRadius: 3}}>
      <CardContent>
        <Stack direction="row" alignItems="flex-start" justifyContent="space-between" gap={2}>
          <Box flex={1} minWidth={0}>
            <Typography variant="h6" component="div" sx={{fontWeight: 600}}>
              {item.name}
            </Typography>

            <Typography variant="body2" color="text.secondary" sx={{mt: 0.5}}>
              #{item.id} • Last Edited on {fmtDateTime(item.editedAt)}
            </Typography>

            <Stack direction="row" alignItems="center" spacing={1} sx={{mt: 1.5}}>
              <FiberManualRecordIcon
                fontSize="small"
                sx={{color: item.status === 'active' ? 'success.main' : 'text.disabled'}}
              />
              <Typography variant="body2" color="text.secondary" sx={{textTransform: 'capitalize'}}>
                {item.status}
              </Typography>
            </Stack>
          </Box>

          <Stack direction="row" alignItems="center" spacing={0.5}>
            <Tooltip title="Test">
              <IconButton size="small" onClick={() => {
                onTest(item.id);
              }}>
                <SendIcon fontSize="small"/>
              </IconButton>
            </Tooltip>

            <Tooltip title="Edit">
              <IconButton size="small" href={`/templates/${item.id}/edit`}>
                <EditOutlinedIcon/>
              </IconButton>
            </Tooltip>

            <IconButton onClick={handleMenuClick} size="small">
              <MoreVertIcon/>
            </IconButton>
          </Stack>
        </Stack>
      </CardContent>
    </Card>
  );
}
